<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>现金日报</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="开始日期">
            <el-date-picker v-model="keywords.begintime" type="date" placeholder="选择年月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model="keywords.endtime" type="date" placeholder="选择年月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Years" label="日期"></el-table-column>
          <el-table-column prop="Xiaoshoushouru" label="销售收入"></el-table-column>
          <el-table-column prop="Fuwufeishouru" label="服务费收入"></el-table-column>
          <el-table-column prop="Qitashouru" label="其他收入"></el-table-column>
          <el-table-column prop="Dangrizhichu" label="当日支出"></el-table-column>
          <el-table-column prop="Qitazhichu" label="其他支出"></el-table-column>
          <el-table-column prop="Dangriyue" label="当日余额"></el-table-column>
          <el-table-column prop="Beizhu" label="备注"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200px" v-if="SubRule_Caiwu_XianjinribaoAdd">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickCaiwu(scope.row)">财务填入</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 弹出框 -->
      <el-dialog :title="addForm.years" :visible.sync="adddialog" width="700px" :close-on-click-modal="false">
        <el-form :model="addForm" ref="addForm" label-width="250px">
          <el-form-item label="其他收入" class="addAdminForm">
            <el-input v-model="addForm.qitashouru"></el-input>
          </el-form-item>
          <el-form-item label="其他支出" class="addAdminForm">
            <el-input v-model="addForm.qitazhichu"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="addForm.beizhu"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="SaveCaiwu">保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹出框 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyXianjinribao',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        years: '',
        qitashouru: '',
        qitazhichu: '',
        beizhu: ''
      },
      // 查询
      keywords: {
        begintime: '',
        endtime: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      adddialog: false,
      SubRule_Caiwu_XianjinribaoAdd: false
    }
  },
  mounted () {
    this.apiXianjinribaolist()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Caiwu_XianjinribaoAdd', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Caiwu_XianjinribaoAdd = true
      }
    })
  },
  methods: {
    clickCaiwu (row) {
      this.adddialog = true
      this.addForm.years = row.Years
      this.addForm.qitashouru = row.Qitashouru
      this.addForm.qitazhichu = row.Qitazhichu
      this.addForm.beizhu = row.Beizhu
    },
    SaveCaiwu () {
      this.apiAddXianjinribao()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiXianjinribaolist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiXianjinribaolist()
    },
    apiXianjinribaolist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Xianjinribaolist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Listnum
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddXianjinribao: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        years: that.addForm.years,
        qitashouru: that.addForm.qitashouru,
        qitazhichu: that.addForm.qitazhichu,
        beizhu: that.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddXianjinribao, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.adddialog = false
            that.apiXianjinribaolist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
